<div *ngIf="!showDetail">
    <p-table *ngIf="!reqOrInv && selectedCountry==='PL'" #inwDt sortMode="multiple" [columns]="headers" [value]="data"
        [paginator]="true" sortMode="multiple" [rowsPerPageOptions]="[5, 10, 25, 50]" [rows]="5"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="{{'text.showing' | translate}} {first} {{'text.to' | translate}} {last} {{'text.of' | translate}} {totalRecords} {{'text.entries' | translate}}"
        [globalFilterFields]="filters" styleClass="p-datatable-gridlines" [scrollable]="true" scrollHeight="300px"
        responsiveLayout="scroll" [resizableColumns]="true" styleClass="p-datatable-sm" class="common-table bordered"
        [resizableColumns]="true" columnResizeMode="expand">
        <ng-template pTemplate="caption">
            <div class="p-d-flex search-input d-flex justify-content-end">
                <span class="p-input-icon-left p-ml-auto">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="inwDt.filterGlobal($event.target.value, 'contains')"
                        placeholder="Search keyword" />
                </span>
            </div>
        </ng-template>
        <ng-template pTemplate="header" let-columns>
            <tr>
                <th *ngFor="let col of headers" pResizableColumn [pSortableColumn]="col.value">
                    {{ col.field }}
                    <p-columnFilter class="ms-auto" type="text" [field]="col.value" display="menu">
                    </p-columnFilter>
                    <p-sortIcon [field]="col.value"></p-sortIcon>
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData>
            <tr>
                <td>
                    {{ rowData.createDate}}
                </td>
                <td>
                    {{ rowData.requestId }}
                </td>
                <td>
                    {{ rowData.createdBy }}
                </td>
                <td>
                    {{ rowData.subject.name}}
                </td>
                <td>
                    {{ rowData.criteria.name}}
                </td>

                <td>
                    {{ rowData.from | date:'yyyy-MM-dd HH:mm:ss':'+01:00'}}
                </td>
                <td>
                    {{ rowData.to | date:'yyyy-MM-dd HH:mm:ss':'+01:00'}}
                </td>
                <td>
                    {{ rowData.status | titlecase}}
                    <download-data style="padding-left: 5px;"
                        *ngIf="rowData.status == 'GENERATED' || rowData.status == 'Generated' && enableManual === true"
                        [type]="'anchor'" [fileName]="rowData.requestId" [bypassCheck]=true [reportCateg]="'reports'"
                        [path]="'GET_MOF'" [disableClass]="downloadButtonEnableManual === true">
                    </download-data>
                    <download-data style="padding-left: 5px;"
                        *ngIf="rowData.status == 'GENERATED' || rowData.status == 'Generated' && enableAuto === true"
                        [type]="'anchor'" [fileName]="rowData.requestId" [bypassCheck]=true [reportCateg]="'reports'"
                        [path]="'GET_MOF'" [disableClass]="downloadButtonEnableAuto === true">
                    </download-data>
                    <i *ngIf="rowData.status == 'FAILED' && rowData.errorMessage !==null && rowData.errorMessage !==undefined"
                        class="me-2" style='color: #9ca3a8; padding-left: 5px;' class="pi pi-info-circle"
                        pTooltip="{{rowData.errorMessage}}"></i>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="7">{{'text.noData' | translate}}.</td>
            </tr>
        </ng-template>
    </p-table>
    <p-table *ngIf="!reqOrInv && (selectedCountry === 'RO' || selectedCountry === 'MY' || selectedCountry === 'IT')"
        #inwDt sortMode="multiple" [columns]="headers" [value]="data" [paginator]="true" sortMode="multiple"
        [rowsPerPageOptions]="[5, 10, 25, 50]" [rows]="5" [showCurrentPageReport]="true"
        currentPageReportTemplate="{{'text.showing' | translate}} {first} {{'text.to' | translate}} {last} {{'text.of' | translate}} {totalRecords} {{'text.entries' | translate}}"
        [globalFilterFields]="filters" styleClass="p-datatable-gridlines" [scrollable]="true" scrollHeight="300px"
        responsiveLayout="scroll" [resizableColumns]="true" styleClass="p-datatable-sm" class="common-table bordered"
        [resizableColumns]="true" columnResizeMode="expand">

        <ng-template pTemplate="caption">
            <div class="p-d-flex search-input d-flex justify-content-end">
                <span class="p-input-icon-left p-ml-auto">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="inwDt.filterGlobal($event.target.value, 'contains')"
                        placeholder="Search keyword" />
                </span>
            </div>
        </ng-template>
        <ng-template pTemplate="header" let-columns>
            <tr>
                <th *ngFor="let col of headers" pResizableColumn [pSortableColumn]="col.value">
                    {{ col.field }}<i *ngIf="col?.toolTip" class="pi pi-info-circle info-tooltip"
                        [tooltipPosition]="'top'" pTooltip="{{ col.toolTipValue }}">
                    </i>
                    <p-columnFilter class="ms-auto" type="text" [field]="col.value" display="menu"></p-columnFilter>
                    <p-sortIcon [field]="col.value"></p-sortIcon>
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData>
            <tr>
                <td>{{ rowData?.createdDate }}</td>
                <td>{{ rowData.requestId }}</td>
                <td>{{ rowData.userName }}</td>
                <td *ngIf="selectedCountry === 'MY'">{{ rowData.direction }}</td>
                <td>{{ rowData.mode }}</td>
                <td *ngIf="selectedCountry === 'RO' || selectedCountry === 'MY'">{{ rowData.from }}</td>
                <td *ngIf="selectedCountry === 'RO' || selectedCountry === 'MY'">{{ rowData.to }}</td>
                <td>
                    <span *ngIf="!['Submitted', 'Inprogress', 'INPROGRESS'].includes(rowData.status)">
                        {{ rowData?.updatedDate }}
                    </span>
                </td>
                <td>
                    {{ rowData.status | titlecase }}
                    <span *ngIf="selectedCountry === 'MY' && rowData.partFileNo != null && rowData.partFileNo != '0'  && (rowData?.status)?.toUpperCase()?.includes('COMPLETED')" style="padding-left: 0.25rem;">
                        {{ rowData.partFileNo }}
                      </span>
                      <span *ngIf="selectedCountry === 'MY' && (rowData.partFileNo == '0' || rowData.partFileNo == null) && (rowData?.status)?.toUpperCase()?.includes('COMPLETED')" style="padding-left: 0.25rem;">
                        0
                       </span>
                    <ng-container>
                        <download-data style="padding-left: 5px;"
                            *ngIf="(rowData?.status).toUpperCase()?.includes('COMPLETED')" [type]="'anchor'"
                            [fileName]="rowData.requestId" [bypassCheck]="true" [reportCateg]="'reports'" [path]="path"
                            [date]="rowData.updateDate"
                            [disableClass]="selectedCountry === 'MY' && rowData?.partFileNo == '0'">
                        </download-data>
                    </ng-container>
                    <i *ngIf="(rowData.status === 'FAILED' || (rowData.status == 'INPROGRESS' && selectedCountry == 'MY')) && rowData.errorMessage" class="me-2 pi pi-info-circle"
                        style="color: #9ca3a8; padding-left: 5px;" pTooltip="{{ rowData.errorMessage }}">
                    </i>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="7">{{'text.noData' | translate}}.</td>
            </tr>
        </ng-template>
    </p-table>

    <p-table *ngIf="!reqOrInv && selectedCountry === 'AU'" #inwDt sortMode="multiple" [columns]="headers" [value]="data"
        [paginator]="true" sortMode="multiple" [rowsPerPageOptions]="[5, 10, 25, 50]" [rows]="5"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="{{'text.showing' | translate}} {first} {{'text.to' | translate}} {last} {{'text.of' | translate}} {totalRecords} {{'text.entries' | translate}}"
        [globalFilterFields]="filters" styleClass="p-datatable-gridlines" [scrollable]="true" scrollHeight="300px"
        responsiveLayout="scroll" [resizableColumns]="true" styleClass="p-datatable-sm" class="common-table bordered"
        [resizableColumns]="true" columnResizeMode="expand">

        <ng-template pTemplate="caption">
            <div class="p-d-flex search-input d-flex justify-content-end">
                <span class="p-input-icon-left p-ml-auto">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="inwDt.filterGlobal($event.target.value, 'contains')"
                        placeholder="Search keyword" />
                </span>
            </div>
        </ng-template>
        <ng-template pTemplate="header" let-columns>
            <tr>
                <th *ngFor="let col of headers" pResizableColumn [pSortableColumn]="col.value" [pTooltip]="col.tooltip"
                    [tooltipStyleClass]="'custom-tooltip'">
                    {{ col.field }}
                    <p-columnFilter class="ms-auto" type="text" [field]="col.value" display="menu">
                    </p-columnFilter>
                    <p-sortIcon [field]="col.value"></p-sortIcon>
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData>
            <tr>
                <td>
                    {{ rowData?.createdDate}}
                </td>
                <td>
                    {{ rowData.source }}
                </td>
                <td>
                    {{ rowData.requestId }}
                </td>
                <td>
                    {{ rowData.userName }}
                </td>
                <td>
                    {{ rowData.party }}
                </td>
                <td>
                    {{ rowData.participantID }}
                </td>
                <td>
                    {{ rowData.mode }}
                </td>
                <td>
                    {{ rowData.from }}
                </td>
                <td>
                    {{ rowData.to}}
                </td>
                <!-- <td>
                {{ rowData?.updatedDate}}
            </td> -->
                <td>
                    {{ rowData.status | titlecase}}
                    <!-- <download-data style="padding-left: 5px;"
                    *ngIf="rowData.status == 'COMPLETED' || rowData.status == 'Completed'" [type]="'anchor'"
                    [fileName]="rowData.requestId" [bypassCheck]=true [reportCateg]="'reports'" [path]="path"
                    [date]="rowData.updateDate">
                </download-data> -->
                    <i *ngIf="rowData.status == 'FAILED' && rowData.errorMessage !==null && rowData.errorMessage !==undefined"
                        class="me-2" style='color: #9ca3a8; padding-left: 5px;' class="pi pi-info-circle"
                        pTooltip="{{rowData.errorMessage}}"></i>
                </td>
                <td>
                    {{ rowData.totalFetched}}
                </td>
                <td>
                    {{ rowData.success}}
                </td>
                <td>
                    {{ rowData.error}}
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="7">{{'text.noData' | translate}}.</td>
            </tr>
        </ng-template>
    </p-table>

    <p-table *ngIf="reqOrInv && !isHistory" #inwDt sortMode="multiple" [columns]="headers" [value]="data"
        (click)="updateOutput()" [paginator]="true" [rowsPerPageOptions]="[5, 10, 25, 50]" [rows]="5"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="{{'text.showing' | translate}} {first} {{'text.to' | translate}} {last} {{'text.of' | translate}} {totalRecords} {{'text.entries' | translate}}"
        [globalFilterFields]="filters" styleClass="p-datatable-gridlines" [scrollable]="true" scrollHeight="300px"
        responsiveLayout="scroll" styleClass="p-datatable-sm" class="common-table bordered" [resizableColumns]="true"
        columnResizeMode="expand" [(selection)]="selectedXmlRows">
        <ng-template pTemplate="caption">
            <div class="p-d-flex search-input d-flex justify-content-end">
                <span class="p-input-icon-left p-ml-auto">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="inwDt.filterGlobal($event.target.value, 'contains')"
                        placeholder="Search Keyword" />
                </span>
            </div>
        </ng-template>
        <ng-template pTemplate="header" let-columns>
            <tr>
                <th style="margin-right: -96px">
                    <p-tableHeaderCheckbox *ngIf="!isHistory" #headerCheckBox
                        (click)="getSelectedAll($event)"></p-tableHeaderCheckbox>
                </th>
                <ng-container *ngFor="let col of headers">
                    <th *ngIf="col?.disbledSortFilter && col?.type != 'innerHTML'" pResizableColumn
                        [ngClass]="{'kseF-tab-width':col.value==='enum' || col.value ==='saleOssNet' || col.value ==='saleOssVat'}">
                        {{ col.field }}
                    </th>
                    <th *ngIf="!col?.disbledSortFilter && col?.type != 'innerHTML'" pResizableColumn [pSortableColumn]="col.value"
                        [ngClass]="{'kseF-tab-width':col.value==='enum' || col.value ==='saleOssNet' || col.value ==='saleOssVat'}">
                        {{ col.field }}
                        <p-columnFilter class="ms-auto" type="text" [field]="col.value" display="menu"></p-columnFilter>
                        <p-sortIcon [field]="col.value"></p-sortIcon>
                    </th>
                    <th *ngIf="col?.type == 'innerHTML'" pResizableColumn  
                        [ngClass]="{'kseF-tab-width':col.value==='enum' || col.value ==='saleOssNet' || col.value ==='saleOssVat'}">
                        {{ col.field }}
                    </th>
                </ng-container>

            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns">
            <tr>
                <td style="margin-right: -96px">
                    <p-tableCheckbox *ngIf="!isHistory" [value]='rowData'
                        (click)="getSelectedRowData(rowData, $event)"></p-tableCheckbox>
                </td>
                <td *ngFor="let col of columns"
                    [ngClass]="{'kseF-tab-width':col.value==='enum' || col.value ==='saleOssNet' || col.value ==='saleOssVat'}">
                    <a *ngIf="col.link" style="cursor: pointer;" class="invoice-link" tabindex="0"
                        (click)="selectedInput = rowData;showDetail = true; hideOrShowInwardDetail(false)"
                        [attr.aria-label]="rowData[col.value]">
                        {{ rowData[col.value] }}
                    </a>
                    <span *ngIf="!col.link && col.type !== 'innerHTML'">
                        {{ rowData[col.value] }}
                    </span>
                    <span *ngIf="col.innerHTML && col.type === 'innerHTML'">
                        <ng-container
                            *ngIf="rowData[col.value] && (rowData[col.value].includes('URL - &lt;a&gt;No&lt;/a&gt;')); else elseBlock">
                            <div [innerHTML]="rowData[col.value]"></div>
                        </ng-container>
                        <ng-template #elseBlock>
                            <div [id]="'attachmentExist'" [innerHTML]="rowData[col.value]"></div>
                        </ng-template>
                    </span>
                    <span *ngIf="col.button">
                        <button pButton pRipple type="button" (click)="onClickAddResponce(rowData)" icon="pi pi-plus"
                            class="add-response p-element p-button-raised p-button-sm p-button m-0"
                            aria-label="Add New Message dialog"></button>
                    </span>
                    <i *ngIf="col.value == 'lastMessageStatusWithDate' && rowData[col.value].includes('Failed')"
                        class="me-2" style='color: #9ca3a8; padding-left: 5px;' tooltipPosition="left"
                        class="pi pi-info-circle" pTooltip="{{rowData.errorMessage}}">
                    </i>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="0">{{'text.noData' | translate}}.</td>
            </tr>
        </ng-template>
    </p-table>

    <p-table *ngIf="isHistory" #inwDt sortMode="multiple" [columns]="headers" [value]="data" (click)="updateOutput()"
        [paginator]="true" [rowsPerPageOptions]="[5, 10, 25, 50]" [rows]="5" [showCurrentPageReport]="true"
        currentPageReportTemplate="{{'text.showing' | translate}} {first} {{'text.to' | translate}} {last} {{'text.of' | translate}} {totalRecords} {{'text.entries' | translate}}"
        [globalFilterFields]="filters" styleClass="p-datatable-gridlines" [scrollable]="true" scrollHeight="300px"
        responsiveLayout="scroll" styleClass="p-datatable-sm" class="common-table bordered" [resizableColumns]="true"
        columnResizeMode="expand" [(selection)]="selectedXmlRows">
        <ng-template pTemplate="caption">
            <div class="p-d-flex search-input d-flex justify-content-end">
                <span class="p-input-icon-left p-ml-auto">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="inwDt.filterGlobal($event.target.value, 'contains')"
                        placeholder="Search Keyword" />
                </span>
            </div>
        </ng-template>
        <ng-template pTemplate="header" let-columns>
            <tr>
                <th style="margin-right: -96px">
                    <p-tableHeaderCheckbox *ngIf="!isHistory" #headerCheckBox
                        (click)="getSelectedAll($event)"></p-tableHeaderCheckbox>
                </th>
                <ng-container *ngFor="let col of headers">
                    <th *ngIf="col?.disbledSortFilter" pResizableColumn
                        [ngClass]="{'kseF-tab-width':col.value==='enum' || col.value ==='saleOssNet' || col.value ==='saleOssVat'}">
                        {{ col.field }}
                    </th>
                    <th *ngIf="!col?.disbledSortFilter" pResizableColumn [pSortableColumn]="col.value"
                        [ngClass]="{'kseF-tab-width':col.value==='enum' || col.value ==='saleOssNet' || col.value ==='saleOssVat'}">
                        {{ col.field }}
                        <p-columnFilter class="ms-auto" type="text" [field]="col.value" display="menu"></p-columnFilter>
                        <p-sortIcon [field]="col.value"></p-sortIcon>
                    </th>
                </ng-container>

            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns">
            <tr>
                <td style="margin-right: -96px">
                    <p-tableCheckbox *ngIf="!isHistory" [value]='rowData'
                        (click)="getSelectedRowData(rowData, $event)"></p-tableCheckbox>
                </td>
                <td *ngFor="let col of columns"
                    [ngClass]="{'kseF-tab-width':col.value==='enum' || col.value ==='saleOssNet' || col.value ==='saleOssVat'}">
                    <a *ngIf="col.link" style="cursor: pointer;" class="invoice-link" tabindex="0"
                        (click)="selectedInput = rowData;showDetail = true; hideOrShowInwardDetail(false)"
                        [attr.aria-label]="rowData[col.value]">
                        {{ rowData[col.value] }}
                    </a>
                    <span *ngIf="!col.link && col.type !== 'innerHTML'">
                        {{ rowData[col.value] }}
                    </span>
                    <span *ngIf="col.innerHTML && col.type === 'innerHTML' && selectedCountry !== 'IT'">
                        <ng-container
                            *ngIf="rowData[col.value] && rowData[col.value].includes('URL - &lt;a&gt;No&lt;/a&gt;'); else elseBlock">
                            <div [innerHTML]="rowData[col.value]"></div>
                        </ng-container>
                        <ng-template #elseBlock>
                            <div [id]="'attachmentExist'" [innerHTML]="rowData[col.value]"></div>
                        </ng-template>
                    </span>
                    <span *ngIf="col.innerHTML && col.type === 'innerHTML' && selectedCountry == 'IT'">
                        <ng-container
                            *ngIf="rowData[col.value] && rowData[col.value].includes('URL - &lt;a&gt;NA&lt;/a&gt;'); else elseBlock">
                            <div [innerHTML]="rowData[col.value]"></div>
                        </ng-container>
                        <ng-template #elseBlock>
                            <div [id]="'attachmentExist'" [innerHTML]="rowData[col.value]"></div>
                        </ng-template>
                    </span>
                    <span *ngIf="col.button">
                        <button pButton pRipple type="button" (click)="onClickAddResponce(rowData)" icon="pi pi-plus"
                            class="add-response p-element p-button-raised p-button-sm p-button m-0"
                            aria-label="Add New Message dialog"></button>
                    </span>
                    <i *ngIf="col.value == 'lastMessageStatusWithDate' && rowData[col.value].includes('Failed')"
                        class="me-2" style='color: #9ca3a8; padding-left: 5px;' tooltipPosition="left"
                        class="pi pi-info-circle" pTooltip="{{rowData.errorMessage}}">
                    </i>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="0">{{'text.noData' | translate}}.</td>
            </tr>
        </ng-template>
    </p-table>
</div>

<div *ngIf="showDetail">
    <button pButton type="button" [autofocus]="true" aria-label="back" style="float: right;position: relative;"
        class="ey-button-dark m-2 mt-0" (click)='showDetail = false; hideOrShowInwardDetail(true)'>{{'text.back' |
        translate}}</button>

    <app-invoicemanagementDD [selectedRecords]="selectedInput" [pageType]="'IN'"></app-invoicemanagementDD>

</div>
